import { useState } from 'react';
import axios from 'axios';
import {
  FaUserMd,
  FaHospital,
  FaTimes
} from 'react-icons/fa';
import API_URL from '../config';

function LoginModal({ isOpen, onClose }) {

  const [role, setRole] = useState('candidate');
  const [isRegister, setIsRegister] = useState(false);

  const [form, setForm] = useState({
    name: '',
    phone: '',
    password: ''
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {

    try {

      if (isRegister) {

        await axios.post(`${API_URL}/auth/register`, {
          ...form,
          role
        });

        alert('Registration successful');
        setIsRegister(false);

      } else {

        const res = await axios.post(
  `${API_URL}/auth/login`,
  {
    phone: form.phone,
    password: form.password,
    role: role
  }
);

        localStorage.setItem(
          'user',
          JSON.stringify(res.data.user)
        );

        alert('Login successful');

        if (res.data.user.role === 'institution') {
          window.location.href = '/institution';
        } else {
          window.location.href = '/dashboard';
        }

      }

    } catch (err) {
      console.log(err);
alert(
    err.response?.data?.message ||
    "Something went wrong"
);    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">

      <div className="bg-white/90 backdrop-blur-xl rounded-3xl shadow-2xl w-full max-w-md overflow-hidden border border-white/30 relative animate-fadeIn">

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-gray-500 hover:text-red-500 text-xl"
        >
          <FaTimes />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-r from-teal-600 to-emerald-700 text-white p-8 text-center">

          <h2 className="text-3xl font-bold">
            {isRegister ? 'Create Account' : 'Welcome Back'}
          </h2>

          <p className="mt-2 text-teal-100">
            Access premium healthcare opportunities
          </p>

        </div>

        {/* Body */}
        <div className="p-8">

          {/* Role Toggle */}
          <div className="grid grid-cols-2 gap-4 mb-6">

            <button
              onClick={() => setRole('candidate')}
              className={`p-4 rounded-2xl border transition ${
                role === 'candidate'
                  ? 'bg-teal-600 text-white border-teal-600'
                  : 'bg-white text-gray-700'
              }`}
            >
              <FaUserMd className="mx-auto text-2xl mb-2" />
              Job Seeker
            </button>

            <button
              onClick={() => setRole('institution')}
              className={`p-4 rounded-2xl border transition ${
                role === 'institution'
                  ? 'bg-teal-600 text-white border-teal-600'
                  : 'bg-white text-gray-700'
              }`}
            >
              <FaHospital className="mx-auto text-2xl mb-2" />
              Recruiter
            </button>

          </div>

          {/* Register Name */}
          {isRegister && (
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              onChange={handleChange}
              className="w-full p-4 border rounded-2xl mb-4 outline-none focus:ring-2 focus:ring-teal-500"
            />
          )}

          {/* Phone */}
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            onChange={handleChange}
            className="w-full p-4 border rounded-2xl mb-4 outline-none focus:ring-2 focus:ring-teal-500"
          />

          {/* Password */}
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            className="w-full p-4 border rounded-2xl mb-6 outline-none focus:ring-2 focus:ring-teal-500"
          />

          {/* Submit */}
          <button
            onClick={handleSubmit}
            className="w-full bg-gradient-to-r from-teal-600 to-emerald-700 text-white py-4 rounded-2xl font-semibold hover:opacity-90 transition"
          >
            {isRegister ? 'Create Account' : 'Login'}
          </button>

          {/* Toggle */}
          <div className="text-center mt-6">

            <button
              onClick={() => setIsRegister(!isRegister)}
              className="text-teal-700 font-medium"
            >
              {isRegister
                ? 'Already have an account? Login'
                : 'New user? Create account'}
            </button>

          </div>

        </div>

      </div>

    </div>
  );
}

export default LoginModal;






/*import { useState } from 'react';
import axios from 'axios';

function Login() {

  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    console.log("Sending:", phone, password);

    try {
      const res = await axios.post(`${API_URL}/auth/login`, {
        phone,
        password
      });

      alert(res.data.message);

      // ✅ MUST STORE USER
      localStorage.setItem("user", JSON.stringify(res.data.user));

      // ✅ Redirect based on role
      if (res.data.user.role === "institution") {
        window.location.href = "/institution";
      } else {
        window.location.href = "/dashboard";
      }

    } catch (err) {
      console.log("ERROR:", err.response?.data);
      alert(err.response?.data?.message || 'Login failed');
    }
  };

  return (
  <div className="min-h-screen flex items-center justify-center bg-gray-100">

    <div className="bg-white p-6 rounded shadow w-96">

      <h2 className="text-xl font-bold mb-4">Login</h2>

      <input
        type="text"
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        className="w-full border p-2 mb-3"
      />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full border p-2 mb-3"
      />

      <button
        onClick={handleLogin}
        className="w-full bg-blue-500 text-white p-2 rounded"
      >
        Login
      </button>

      {/* ✅ ADD THIS HERE */
    /*}
      <p className="text-sm mt-4 text-center">
        Don’t have an account?{" "}
        <span
          className="text-blue-500 cursor-pointer"
          onClick={() => window.location.href = "/register"}
        >
          Register
        </span>
      </p>

    </div>
  </div>
);
}

export default Login;*/
